import { makeAuthenticatedRequest } from './authService';
import { Note } from './notesService'; // Assuming you have a notesService with Note type

// Interfaces
export interface EncounterReference {
  note_id: string;
  encounter_date: string;
}

export interface Person {
  id: number;
  user_id: number;
  name: string;
  email?: string;
  phone?: string;
  notes?: string;
  properties: {
    encounters?: EncounterReference[];
  };
  created_at: string;
  updated_at: string;
}

export interface PersonEncounter extends Note {}

export interface CreatePersonData {
  user_id: number;
  name: string;
  email?: string;
  phone?: string;
  notes?: string;
}

export interface UpdatePersonData {
  name?: string;
  email?: string;
  phone?: string;
  notes?: string;
  properties?: {
    encounters?: EncounterReference[];
  };
}

export interface CreateEncounterData {
  user_id: number;
  encounter_date: string; // YYYY-MM-DD
  blocks: any[]; // Block content for the note
  title?: string;
}

export const peopleService = {
  // People CRUD
  createPerson: async (data: CreatePersonData): Promise<{ success: boolean; id: number; message: string }> => {
    return makeAuthenticatedRequest(`/people`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  getPeopleByUserId: async (userId: number, search?: string): Promise<{ success: boolean; people: Person[] }> => {
    let url = `/people/user/${userId}`;
    if (search) {
        url += `?search=${encodeURIComponent(search)}`;
    }
    return makeAuthenticatedRequest(url);
  },

  getPersonById: async (personId: number): Promise<{ success: boolean; person: Person }> => {
    return makeAuthenticatedRequest(`/people/${personId}`);
  },

  updatePerson: async (personId: number, data: UpdatePersonData): Promise<{ success: boolean; message: string }> => {
    return makeAuthenticatedRequest(`/people/${personId}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  deletePerson: async (personId: number): Promise<{ success: boolean; message: string }> => {
    return makeAuthenticatedRequest(`/people/${personId}`, {
      method: 'DELETE',
    });
  },

  // Encounters
  createEncounter: async (personId: number, data: CreateEncounterData): Promise<{ success: boolean; note_id: string; message: string }> => {
    return makeAuthenticatedRequest(`/people/${personId}/encounters`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },
  
  getEncounters: async (personId: number, userId: number): Promise<{ success: boolean; encounters: PersonEncounter[] }> => {
    return makeAuthenticatedRequest(`/people/${personId}/encounters?user_id=${userId}`);
  },
  
  updateEncounter: async (noteId: string, userId: number, data: { blocks: any[], title: string }): Promise<{ success: boolean; message: string }> => {
      return makeAuthenticatedRequest(`/people/encounters/${noteId}`, {
          method: 'PUT',
          body: JSON.stringify({ ...data, user_id: userId }),
      });
  },

  deleteEncounter: async (personId: number, noteId: string, userId: number): Promise<{ success: boolean; message: string }> => {
      return makeAuthenticatedRequest(`/people/${personId}/encounters/${noteId}`, {
          method: 'DELETE',
          body: JSON.stringify({ user_id: userId }),
      });
  },
};
